import React from 'react';
import { createBrowserHistory } from 'history';  // ✅ Correct
import { Link } from "react-router-dom";
import 'font-awesome/css/font-awesome.min.css';
import _, { filter } from 'lodash';
import '../css/regokas.css';
import '../css/support.css';
import Error from '../images/Error.svg';
import View from '../images/view.svg';
import User from '../images/user.png';
import Supportokas from '../images/supportokas.png';
import Loader from '../components/loader';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import SearchBar from './SearchBar';
import { Cell, Label, Pie, PieChart } from 'recharts';
import { is_allowed } from '../utils';
import { Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';



class Support extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: [],
            selectedTicketIds: [],
            assignableUsers: [],
            selectedUserId: null,
            supportTicketData: [],
            currentPage: 1,
            next: null,
            displayText: "Total Tickets", // Default display text
            isSearching: false, // New state to control div visibility
            overdueTickets: 0,
            previous: null,
            rowsPerPage: 10,
            PendingCount: 10,
            OverdueCount: 3,
            ClosedCount: 0,
            kk: 'asdvhj',
            subject: '',
            description: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            debounceTimeout: null,
            actualdata: [],
            disabledvalue: '',
            classshowofmodal: false,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            showchat: '',
            searchbar: '',
            chatData: [],
            ticketvareal: '',
            subjectvareal: '',
            statusvareal: '',
            loader: '',
            topic: '',
            attechment: [],
            currentPage: 1,
            statuson: false,
            statustw: false,
            statusth: false,
            statusfo: false,
            statusfi: false,
            statussi: false,
            statusse: false,
            statusei: false,
            statusni: false,
            statuste: false,
            todosPerPage: 10,
            showsupportimg: false,
            supportmainimg: '',
            usersname: '',
            usersemail: '',
            checkuserApidata: '',
            openTicket: '',
            openSubject: '',
            openDescription: '',
            openStatus: '',
            first_name: '',
            filter: null,
            count: {
                pie_chart: {},
                horizontal_chart: {}
            }
        };

    }

    // Handle page change
    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    };

    componentWillMount() {
        this.checkuserApi();


    }
    getFiles(files) {
        this.setState({ attechment: files })
    }


    componentDidMount() {

        this.interval = setInterval(() => {
            // alert('Server Error.'); 
        }, 1000);



    }
    scrolltodown() {
        let height = document.documentElement.scrollHeight;
        let addheight = height + 500;
        window.scrollTo(0, addheight)
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
    }

    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }.bind(this), 3000
        );
    }
    //------------------------------------------------ error msg function end ------------------------------------------------

    checkuserApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {

                this.setState({
                    checkuserApidata,
                    actualdata: checkuserApidata
                }, () => {
                    this.props.userNameStyleActivate(this.state.checkuserApidata.user_name)
                    this.props.reuserNameStyleActivate(this.state.checkuserApidata.first_name)
                })
            })
    }



    // support data api
    componentDidMount() {


        // Getting the authorization token from localStorage
        let TokenValue = 'Token ' + localStorage.getItem("auth");

        // Fetch the first page of support ticket data
        this.fetchData('/we/supportticket/', TokenValue);

        // Fetch the pending ticket count
        this.fetchCount(TokenValue);
        this.fetchAssignableUsers();

    }

    // Reusable method to fetch paginated data
    fetchData = (url, TokenValue) => {
        fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': TokenValue, // Send authorization token with the request
                'X-CSRFToken': localStorage.getItem('csrftoken')
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON response
            })
            .then(data => {

                // console.log(data.results);
                this.setState({
                    totaltickets: data.count
                })
                // console.log(this.state.totaltickets)
                const { results, next, previous } = data;
                if (next) {
                    // Create a URL object
                    const next_url = new URL(next);

                    // Get the value of the "page" parameter
                    const nextValue = next_url.searchParams.get("page");
                    this.setState({
                        next: nextValue,
                    });
                } else {
                    this.setState({
                        next: null
                    });
                }
                if (previous != null) {
                    // Create a URL object
                    const previous_url = new URL(previous);

                    // Get the value of the "page" parameter
                    const previousValue = previous_url.searchParams.get("page") || 1;
                    this.setState({
                        previous: previousValue,
                    });
                } else {
                    this.setState({
                        previous: null
                    });
                }
                // Set the data and pagination links to state
                this.setState({
                    okasBoxData: results
                });
                // console.log(this.state.okasBoxData)
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }

    handleSearch = (searchValue) => {
        clearTimeout(this.debounceTimeout); // Clear previous timeout
        this.debounceTimeout = setTimeout(() => {
            this.fetchData(`/we/supportticket/?search=${searchValue}`);
        }, 500); // Wait for 500ms before making API call
    };

    // Reusable method to fetch counts
    fetchCount = (TokenValue) => {
        fetch('we/supportStats/', {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': TokenValue, // Send the same authorization token
                'X-CSRFToken': localStorage.getItem('csrftoken')
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON response
            })
            .then(data => {
                // Dynamically update the corresponding state key with the count
                this.setState({ count: data });

            })

            .catch(error => {
                console.error(`There was an error fetching:`, error);
            });

    }
    // Handle pending tickets filter
    handlependingtakeaction = () => {
        this.setState({
            filter: "pending", displayText: "Total pending tickets", overdueTickets: this.state.count.pending // Update display text
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");

        // Call API for pending tickets
        this.fetchData('/we/supportticket/?pending=true', TokenValue);
    };

    // Handle overdue tickets filter
    handleticketoverduetakeaction = () => {
        this.setState({
            filter: "overdue", displayText: "Total overdue tickets", overdueTickets: this.state.count.overdue // Update display text
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");

        // Call API for overdue tickets
        this.fetchData('/we/supportticket/?overdue=true', TokenValue);
    };


    // Handle next page
    handleNext = () => {
        const { next } = this.state;
        const TokenValue = 'Token ' + localStorage.getItem("auth");
        let filter = ''
        switch (this.state.filter) {
            case 'pending':
                filter = '&pending=true'
                break;
            case 'overdue':
                filter = '&overdue=true'
                break;
            default:
                filter = ''
                break;
        }
        if (next) {
            this.fetchData(`/we/supportticket?page=${next}${filter}&search=${this.state.searchValue}`, TokenValue);
        }
    };

    // Handle previous page
    handlePrevious = () => {
        const { previous } = this.state;
        const TokenValue = 'Token ' + localStorage.getItem("auth");
        let filter = ''
        switch (this.state.filter) {
            case 'pending':
                filter = '&pending=true'
                break;
            case 'overdue':
                filter = '&overdue=true'
                break;
            default:
                filter = ''
                break;
        }
        if (previous) {
            this.fetchData(`/we/supportticket?page=${previous}${filter}&search=${this.state.searchValue}`, TokenValue);
        }
    };


    //------------------------------------------------ main data get API end------------------------------------------------

    handleClickpage(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }


    toDataURL = (url, callback) => {
        var httpRequest = new XMLHttpRequest();
        httpRequest.onload = function () {
            var fileReader = new FileReader();
            fileReader.onloadend = function () {
                callback(fileReader.result);
            }
            fileReader.readAsDataURL(httpRequest.response);
        };
        httpRequest.open('GET', url);
        httpRequest.responseType = 'blob';
        httpRequest.send();
    }

    imgUrlToBase64 = (url) => {
        url = '/media/' + url;
        this.toDataURL(url, (dataUrl) => {
            this.setState({
                supportmainimg: dataUrl,
            }, () => console.log(this.state.supportmainimg))
        })
    }


    opensupportimage = (attachment, action) => {
        if (action == 'open') {
            this.imgUrlToBase64(attachment);
        }
        this.setState({
            showsupportimg: !this.state.showsupportimg,
        });
    }

    openModelWithTicketId = (ticketId, subject, description, status) => {
        this.setState({ //the error happens here
            openTicket: ticketId,
            openSubject: subject,
            openDescription: description,
            openStatus: status,
        });
    }

    //------------------------------------------------ print main data(List view) function start----------------------------
    renderTableData = (type) => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);

        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map(number => {
                return (
                    <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                );
            });
            return renderPageNumbers;
        }

        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                let ticketsid = "/chat/" + e.ticket_id;


                return (
                    <tr key={index} data-toggle="modal" data-target="#myModal"
                        onClick={this.openModelWithTicketId.bind(this, e.id, e.subject, e.description, e.status)}
                    >
                        <td> {e.id} </td>
                        <td>{e.subject}</td>
                        <td>{e.status}</td>
                    </tr>
                )
            });
            return xx;
        }
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }
    ////------------------------------------------------ Delete Succ msg end//------------------------------------------------

    oncolseClickHandler = (event) => {
        this.setState({
            subject: '',
            description: '',
        })
    }
    // --------------------------------------------------------open model function start----------------------------
    onopenmodel = (event) => {
        this.setState({
            showmodels: 'true',
        })
        this.props.searchBarActivate(false)
    }
    // --------------------------------------------------------open model function end----------------------------
    redirectionchat = (ticketva) => {
        const history = createBrowserHistory({ forceRefresh: true });
        localStorage.setItem("ticketid", ticketva);
        history.push('/chat');
    }
    // --------------------------------------------------------open chat function start----------------------------
    onopenchat = (ticketva, subjectva, statusva) => {
        this.setState({
            loader: true,
        })
        this.setState({
            showchat: 'true',
            ticketvareal: ticketva,
            subjectvareal: subjectva,
            statusvareal: statusva,
        })

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let tt = {};
        fetch('/we/we/chatdata/' + ticketva, {
            method: "GET",
            headers: headers,
        })
            .then(response => response.json())
            .then(chatData => {
                this.setState({
                    chatData,
                    actualdata: chatData,
                }, () => {
                })
                this.setState({
                    loader: false,
                })
            })

    }

    //------------------------------------------------ print main data(List view) function start----------------------------
    renderChatData = (type) => {
        console.log(this.state.chatData)
        let counts = this.state.chatData.length
        var typee = 0;
        let xx = this.state.chatData.map((e, index) => {
            typee = typee + 1;
            if (localStorage.getItem('username') == e.user_id)
                return (
                    <div className="row" key={index} >
                        <img src={User} className="imgscal fixed-bottom" />
                        <div className="containeras">
                            <div className="card-body" >
                                <p className="card-text">{e.message}</p>
                            </div>
                        </div>

                    </div>
                )
            else
                return (
                    <div className='Pull-right row' key={index}>
                        <img src={Supportokas} className="right" />
                        <div className="darker">
                            <p>{e.message}</p>
                        </div>
                    </div>
                )
        });
        return xx;
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    onclosechat = (event) => {
        this.setState({
            showchat: '',
        })
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
            error: '',
            topic: '',
            attechment: '',
        })
        this.oncolseClickHandler();
    }
    // --------------------------------------------------------close model function End----------------------------

    // ----------------------------Submit all data in data base POST API Start--------------------------------------
    onSendChatMsgHandler = (val) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let tt;
        let ticket_id = this.state.ticketvareal;
        let subjectvareal = this.state.subjectvareal;
        let statusvareal

        if (val == 'Open') {
            statusvareal = val;
            let status = val;
            tt = {
                ticket_id,
                status,
            }
        } else {
            let message_reply = this.state.livechat;
            statusvareal = this.state.statusvareal;
            tt = {
                ticket_id,
                message_reply,
            }
        }
        fetch('/we/we/ticketreply/', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(tt)
        })
            .then(response => {
                response.json();
                if (response.status == 200) {
                    this.setState({
                        livechat: '',
                    })
                    // this.getallrealdata(); 
                    // this.oncolseClickHandler();
                    // this.errormsg();   
                    // this.setState({
                    //     statusvareal:'Open',
                    // })
                    // console.log(this.state.showchat.scrollHeight)
                    this.onopenchat(ticket_id, subjectvareal, statusvareal);

                } else {
                    this.scrolltodown();
                    alert('Server Errors.');
                }
            })
            .then(data => { })
        this.scrolltodown();
    }
    //---------------------------- Submit all data in data base POST API End----------------------------------------


    // ----------------------------Submit all data in data base POST API Start--------------------------------------
    onAddClickHandler = (buttonaction) => {
        console.log(this.state.attechment.length)

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let tt = {}
        let subject = this.state.subject.trim();
        let body = this.state.description.trim();
        let userName = this.state.checkuserApidata.first_name;
        let email_id = this.state.checkuserApidata.user_name;

        tt = {
            subject,
            body,
            userName,
            email_id,
        };


        if (subject.length < 1) {
            this.setState({
                error: 'Please select Subject',
                subjecterror: 'errorfield',
            })
        } else if (body.length < 1) {
            this.setState({
                error: 'Please enter Topic',
                topicerror: 'errorfield',
            })
        } else {

            this.setState({
                loader: true,
            })

            fetch('/we/we/zendeskApi/', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => {
                    response.json();
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        // this.getallrealdata(); 
                        this.oncolseClickHandler();
                        this.errormsg();
                        if (buttonaction === 'add') {
                            this.onclosemodel();
                        } else if (buttonaction === 'addanother') {
                        }
                    } else {
                        alert('Server Error.');
                    }
                })
                .then(data => { })
            this.setState({
                loader: false,
            })
        }
    }
    //----------------------------------------- Submit all data in data base POST API End----------------------------------------


    //-------------------------------------------Render data after sorting Function Start----------------------------------------------
    restoreData = (data) => {
        this.setState({
            okasBoxData: data,
        })
    }
    //-------------------------------------------Render data after sorting Function End--------------------------------------------------




    //---------------------------------------------------------- sorting Function End--------------------------------------------------


    onSearchClick = () => {
        this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    }
    //opem acces remote form
    // Method to open the form
    handleOpenForm = () => {
        this.setState({ showForm: true });
    };

    // Method to close the form
    handleCloseForm = () => {
        this.setState({ showForm: false });
    };

    fetchAssignableUsers = () => {
        this.setState({ loader: true }); // Start loading

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };

        fetch('/we/addUsers/', {
            method: 'GET',
            headers: headers
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch assignable users');
                }
                return response.json();
            })

            .then(data => {
                const filteredUsers = (data || []).filter(user =>
                    // console.log(user.role.permissions),
                    user.role &&
                    user.role.permissions &&
                    Array.isArray(user.role.permissions.support) &&
                    user.role.permissions.support.length > 0
                );

                this.setState({
                    assignableUsers: filteredUsers
                });
            })
            .catch(error => {
                console.error('Error fetching users:', error);
            })
            .finally(() => {
                this.setState({ loader: false }); // Stop loading
            });
    };

    handleAssignTicket = () => {
        const { selectedTicketIds, selectedUserId, assignableUsers } = this.state;
        const assignedUser = assignableUsers.find(user => user.id === selectedUserId);

        if (!selectedTicketIds || selectedTicketIds.length === 0 || !assignedUser) return;

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };

        const payload = {
            ticket_id: selectedTicketIds,  // ← array of ticket IDs
            assigned_to: assignedUser.user_email
        };

        this.setState({ loader: true });

        fetch('/we/we/assignTicket/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) throw new Error("Failed to assign ticket");

                return response.json();
            })
            .then(data => {

            })
            .catch(error => {
                console.error("Assign ticket error:", error);
            })
            .finally(() => {

                // Reset UI state
                this.setState({
                    loader: false,
                    selectedTicketIds: [],
                    isCheckboxChecked: false,
                    selectedUserId: null
                });
                this.onclosemodel();
                this.fetchData('/we/supportticket/', TokenValue);
            });
    };

    //---------------Edt page data handler ------------------//
    handleEdit = (ticketId) => {

        const ticketData = this.state.okasBoxData.find(row => row.ticket_id === ticketId);
        if (ticketData) {
            this.setState({ formData: ticketData });
        }
    }
    formatTicketTime(seconds) {
        const sec = parseFloat(seconds);

        if (sec < 60) return `${sec.toFixed(0)} sec`;
        if (sec < 3600) {
            const minutes = Math.floor(sec / 60);
            const remainingSec = Math.floor(sec % 60);
            return `${minutes} min ${remainingSec} sec`;
        }
        if (sec < 86400) {
            const hours = Math.floor(sec / 3600);
            const remainingMin = Math.floor((sec % 3600) / 60);
            return `${hours} hr ${remainingMin} min`;
        }

        const days = Math.floor(sec / 86400);
        const remainingHours = Math.floor((sec % 86400) / 3600);
        return `${days} days ${remainingHours} hr`;
    }


    render() {
        const horizontal_data = [
            { name: "minimum", count: this.state.count.horizontal_chart.min_resolve_time },
            { name: "average", count: this.state.count.horizontal_chart.avg_resolve_time },
            { name: "max", count: this.state.count.horizontal_chart.max_resolve_time }
        ]
        const max_horizontal_value = Math.max(...horizontal_data.map(item => item.count), 1); // Avoid division by zero
        const { data, next, previous } = this.state;
        const { currentPage, rowsPerPage, okasBoxData } = this.state;

        // Calculate total pages
        const totalPages = Math.ceil(okasBoxData.length / rowsPerPage);

        // Get rows for the current page
        const currentRows = okasBoxData.slice(
            (currentPage - 1) * rowsPerPage,
            currentPage * rowsPerPage
        );
        return (
            <div className="container dashboardContainer supportSelfContainer" style={{ backgroundColor: "rgb(225, 213, 201)" }}>

                {/* Support Image Section */}
                {this.state.showsupportimg ?
                    <div className="supportdiv">
                        <a className="supportclosediv" onClick={this.opensupportimage.bind(this, 'text', 'close')}>X</a>
                        <div className="supportimgdiv">
                            <img src={this.state.supportmainimg} className="center" />
                        </div>
                    </div>
                    : null}

                {/* Loader */}
                {this.state.loader ? <Loader /> : null}

                {/* Main Content */}

                <span>
                    {/* Search Bar */}
                    {this.props.redux.globalVar.searchBarShow && (
                        <div className='row searchinput' style={{ marginTop: '0.5px' }}>

                            <SearchBar
                                autoFocus
                                value={this.state.searchValue}
                                onChange={(e) => {
                                    this.setState({ searchValue: e, isSearching: true }, () => {
                                        this.handleSearch(this.state.searchValue);
                                    });
                                }}
                                onRequestSearch={() => this.handleSearch(this.state.searchValue)}

                                resetSearch={(e) => {
                                    if (!e) {
                                        // Close button clicked, reset everything
                                        this.setState({ searchValue: "", isSearching: false }, () => {
                                            this.handleSearch(""); // Fetch default data
                                        });
                                    } else {
                                        // Normal reset behavior
                                        this.setState({ searchValue: e, isSearching: !!e }, () => {
                                            this.handleSearch(this.state.searchValue);
                                        });
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Conditionally render the div */}
                    {!this.state.isSearching && (
                        <div className="row">
                            <div className='welcomeMessage'>
                                <h2>OKAS Support Dashboard</h2> <p>Manage & Track Tickets Manage your ticket effectively, take immediate action on pending issues and ensure smooth operations
                                </p>
                            </div>
                        </div>
                    )}
                    {!this.state.isSearching && (
                        <div className="row" style={{ marginBottom: "3rem" }}>
                            <div className="col-md-6">
                                {
                                    this.state.count.horizontal_chart.min_resolve_time &&

                                    <div className="horizontal-chart">
                                        {horizontal_data.map((item, index) => {
                                            // Normalize value as a percentage relative to maxValue
                                            const widthPercentage = (item.count / max_horizontal_value) * 97 || 0;

                                            return (
                                                <div className="bar" key={index}>
                                                    <div className="label-head">
                                                        <div>{item.name} Resolution time</div>
                                                        <span className='count'>{this.formatTicketTime(item.count)}</span>
                                                    </div>
                                                    <div className='bar-bg'>
                                                        <div className="bar-fill" style={{ width: `${widthPercentage}%` }}>

                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                }
                            </div>
                            <div className="col-md-6">
                                {
                                    (this.state.count.pie_chart.pending > 0 || this.state.count.pie_chart.closed > 0 || this.state.count.pie_chart.overdue > 0) &&
                                    <div className="pie-chart">

                                        <PieChart width={200} height={200}>

                                            <Pie data={[
                                                {
                                                    "name": "Closed",
                                                    "value": this.state.count.pie_chart.closed || 0,
                                                    "fill": "rgb(148, 201, 115)"
                                                },
                                                {
                                                    "name": "Pending",
                                                    "value": this.state.count.pie_chart.pending - this.state.count.pie_chart.overdue || 0,
                                                    "fill": "rgb(246, 162, 30)"
                                                },
                                                {
                                                    "name": "Overdue",
                                                    "value": this.state.count.pie_chart.overdue || 0,
                                                    "fill": "rgb(246, 44, 30)"
                                                }
                                            ]} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} animationDuration={1000} // Set animation duration
                                                animationEasing="ease-in-out" >
                                                <Cell
                                                    fill={"rgb(148, 201, 115)"}
                                                />
                                                <Cell
                                                    fill={"rgb(246, 162, 30)"}
                                                />
                                                <Cell
                                                    fill={"rgb(246, 44, 30)"}
                                                />
                                                <Label
                                                    content={<CustomLabel labelText="Total" value={this.state.count.all} />}
                                                    position="center"
                                                />
                                            </Pie>
                                        </PieChart>
                                        <div>
                                            <div>
                                                <h3>{Math.round((this.state.count.pie_chart.closed / this.state.count.all) * 100)}%</h3>
                                                <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                                                    <span style={{ height: "12px", display: "block", width: "12px", borderRadius: "50%", backgroundColor: "rgb(148, 201, 115)" }}></span><span>Closed</span>
                                                </div>
                                            </div>
                                            <div>
                                                <h3>{Math.round(((this.state.count.pie_chart.pending - this.state.count.pie_chart.overdue) / this.state.count.all) * 100)}%</h3>
                                                <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                                                    <span style={{ height: "12px", display: "block", width: "12px", borderRadius: "50%", backgroundColor: "rgb(246, 162, 30)" }}></span><span>Pending</span>
                                                </div>
                                            </div>
                                            <div>
                                                <h3>{Math.round((this.state.count.pie_chart.overdue / this.state.count.all) * 100)}%</h3>
                                                <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                                                    <span style={{ height: "12px", display: "block", width: "12px", borderRadius: "50%", backgroundColor: "rgb(246, 44, 30)" }}></span> <span>Overdue</span>
                                                </div>
                                            </div>
                                            <div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>

                    )}

                    {!this.state.isSearching && (
                        <div className="row">
                            {/* Pending Tickets */}
                            <div className="col-md-3 col-sm-3 text-center">
                                <div className="totalboxcount12">
                                    {/* {this.state.PendingCount} */}
                                    {this.state.count.all}
                                </div>
                                <div className="totalboxcount11">
                                    All Tickets
                                </div>
                            </div>

                            {/* Tickets Resolved */}
                            <div className="col-md-3 col-sm-3 text-center">
                                <div className="totalboxcount12" >
                                    {this.state.count.closed}
                                    <img
                                        src="https://cdn-icons-png.flaticon.com/512/126/126473.png"
                                        alt="Thumbs Up"
                                        className="icon-thumb"
                                    />
                                </div>
                                <div className="cong1" style={{ alignItems: 'center', fontSize: '15px', fontWeight: '600' }}>
                                    Tickets Resolved  <br />within 5 hours <br /> Congratulations!
                                </div>
                            </div>

                            {/* Pending Tickets */}
                            <div className="col-md-3 col-sm-3 text-center">
                                <div className="totalboxcount12">
                                    {/* {this.state.PendingCount} */}
                                    {this.state.count.pending}
                                </div>
                                <div className="totalboxcount11">
                                    Pending Tickets
                                </div>
                                <button
                                    className="action-btn"
                                    onClick={this.handlependingtakeaction}
                                >

                                    Take Action</button>
                            </div>

                            {/* Overdue Tickets */}
                            <div className="col-md-3 col-sm-3 text-center">
                                <div className="totalboxcount12">
                                    {/* {this.state.OverdueCount} */}
                                    {this.state.count.overdue}
                                </div>
                                <div className="totalboxcount11">
                                    Tickets Overdue
                                </div>
                                <button className="action-btn"
                                    onClick={this.handleticketoverduetakeaction}
                                >Take Action</button>
                            </div>

                        </div>

                    )}
                    {!this.state.isSearching && (
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2rem", marginTop: "3rem", alignItems: "center" }}>
                            {/* Remote Access Button */}

                            {/* Welcome Message */}
                            {/* <div className="row"> */}
                            <div className="welcomeMessageBox">
                                <div style={{ display: 'flex', marginBottom: '2%' }}>
                                    {/* Dynamic text display with default as "Total Tickets" */}
                                    <h3 style={{}}> <div className="userName usernamedatas">
                                        {window.innerWidth < 801
                                            ? null
                                            : this.state.displayText}
                                    </div></h3>

                                    <div className="welcomeText"
                                        style={{ textAlign: "left", justifyContent: "flex-end", marginBottom: '2%' }}
                                    >
                                        {/* Manage your ticket effectively ,take immediate action on pending issues and <br>
                                        </br>
                                        ensure smooth operations. */}
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', width: 'auto' }}>

                                {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "support", "request remote access") &&
                                    (this.props.redux.globalVar.userTypeStyle === '3' || this.props.redux.globalVar.userTypeStyle === '1' || this.props.redux.globalVar.userTypeStyle === '4') && (
                                        <Tooltip
                                            title={this.state.isCheckboxChecked ? '' : 'Please select the checkbox first'}
                                            arrow
                                        >
                                            <span>
                                                <a
                                                    onClick={() => {
                                                        if (this.state.isCheckboxChecked) {
                                                            this.onopenmodel();
                                                        }
                                                    }}
                                                    style={{ cursor: this.state.isCheckboxChecked ? 'pointer' : 'not-allowed' }}
                                                >
                                                    <button
                                                        className="action-btn"
                                                        disabled={!this.state.isCheckboxChecked}
                                                    >
                                                        <div className="btntext">Assign Ticket</div>
                                                    </button>
                                                </a>
                                            </span>
                                        </Tooltip>
                                    )}


                                {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "support", "request remote access") && <a href={
                                    // this.props.redux.globalVar.userTypeStyle === '3'
                                    //     ? "/remote-access2"
                                    //     : "/remote-access"
                                    (this.props.redux.globalVar.userTypeStyle === "3" ||
                                        (this.props.redux.globalVar.userTypeStyle === "4" &&
                                            this.state.checkuserApidata.source === 'Distributor'))
                                        ? "/remote-access2"
                                        : "/remote-access"
                                }>
                                    <button className="action-btn">
                                        <div className='btntext'>
                                            Request Remote Access
                                        </div>
                                    </button>
                                </a>}
                            </div>
                        </div>
                    )}
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <table
                            className="table table-striped tablecontent"

                        >
                            <thead
                                className="lookTableHeader"
                                style={{
                                    backgroundColor: "#F28C19",
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    textAlign: "center",
                                    padding: "15px",
                                    borderBottom: "2px solid #ddd"
                                }}
                            >

                                <tr>
                                    {(this.props.redux.globalVar.userTypeStyle === '1' || this.props.redux.globalVar.userTypeStyle === '3' || this.props.redux.globalVar.userTypeStyle === '4') && (
                                        <th style={{
                                            minWidth: "5rem",
                                            backgroundColor: "#F28C19",
                                            verticalAlign: 'start',
                                        }}>
                                            <input type="checkbox" />
                                        </th>
                                    )}

                                    <th style={{
                                        minWidth: "10rem",
                                        backgroundColor: "#F28C19"
                                    }}>TICKET ID</th>
                                    <th style={{
                                        minWidth: "12rem",
                                        backgroundColor: "#F28C19",

                                    }}>STATUS</th>
                                    <th style={{
                                        minWidth: "15rem",
                                        backgroundColor: "#F28C19"
                                    }}>PROJECT DETAILS</th>
                                    {this.props.redux.globalVar.userTypeStyle !== '2' && (
                                        <th
                                            style={{
                                                backgroundColor: "#F28C19",
                                            }}
                                        >
                                            Assigned TO
                                        </th>
                                    )}
                                    {this.props.redux.globalVar.userTypeStyle === '3' && (
                                        <th
                                            style={{
                                                backgroundColor: "#F28C19",
                                            }}
                                        >
                                            SI info
                                        </th>
                                    )}
                                    {this.props.redux.globalVar.userTypeStyle === '3' && (
                                        <th
                                            style={{
                                                minWidth: "12rem",
                                                backgroundColor: "#F28C19",
                                            }}
                                        >
                                            Assigned To <br />{this.state.checkuserApidata.first_name}
                                        </th>
                                    )}
                                    <th style={{
                                        minWidth: "12rem",
                                        backgroundColor: "#F28C19"
                                    }}>LOCATION</th>
                                    <th style={{
                                        backgroundColor: "#F28C19"
                                    }}>SUBSCRIPTION STATUS</th>
                                    <th style={{
                                        backgroundColor: "#F28C19"
                                    }}>REMOTE ACCESS</th>
                                    <th style={{
                                        backgroundColor: "#F28C19",
                                        textAlign: 'center'

                                    }}>ACTIONS</th>
                                </tr>
                            </thead>
                            {/* Table Body */}
                            <tbody>
                                {currentRows.map((row, index) => (
                                    <tr key={index} style={{ cursor: "pointer" }}
                                    >
                                        {(this.props.redux.globalVar.userTypeStyle == '3' || this.props.redux.globalVar.userTypeStyle == '1' || this.props.redux.globalVar.userTypeStyle === '4') && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={(this.state.selectedTicketIds || []).includes(row.custom_ticket_id)}
                                                    onChange={(e) => {
                                                        const { selectedTicketIds } = this.state;
                                                        const isChecked = e.target.checked;
                                                        const id = row.custom_ticket_id;

                                                        this.setState({
                                                            selectedTicketIds: isChecked
                                                                ? [...selectedTicketIds, id]
                                                                : selectedTicketIds.filter(tid => tid !== id),
                                                            isCheckboxChecked: isChecked || selectedTicketIds.length > 1
                                                        });
                                                    }}
                                                />
                                            </td>
                                        )}

                                        <td>
                                            {row.custom_ticket_id}
                                        </td>
                                        <td>
                                            {
                                                (this.props.redux.globalVar.userTypeStyle == "1" || this.props.redux.globalVar.userTypeStyle == "2") ? (row.assign_to_distributor ? <span
                                                    style={{

                                                        display: "inline-block",
                                                        width: "80%",
                                                        textAlign: "center",
                                                        backgroundColor: "#e1d5c9",
                                                        color: "black",
                                                        borderRadius: "5px",
                                                        fontSize: '12px',
                                                        padding: "2px 4px",
                                                    }}
                                                >
                                                    <strong>Assigned To Distributor</strong>
                                                </span> : <span
                                                    style={{

                                                        display: "inline-block",
                                                        width: "80%",
                                                        textAlign: "center",
                                                        backgroundColor:
                                                            row.ticket_status === "hold"
                                                                ? "#D5D528" : row.ticket_status === "closed" ? "#94C973" : row.ticket_status === "open" ? "#F6A21E" : "#94C973",
                                                        color: "#393C46",
                                                        borderRadius: "5px",
                                                        padding: "2px 4px",
                                                    }}
                                                >
                                                    <strong>{row.ticket_status.charAt(0).toUpperCase() + row.ticket_status.slice(1).toLowerCase()}</strong>
                                                </span>) :
                                                    (row.is_assigned_to_okas ? <span
                                                        style={{

                                                            display: "inline-block",
                                                            width: "80%",
                                                            textAlign: "center",
                                                            backgroundColor: "#e1d5c9",
                                                            color: "black",
                                                            borderRadius: "5px",
                                                            fontSize: '12px',
                                                            padding: "2px 4px",
                                                        }}
                                                    >
                                                        <strong>Assigned To OKAS</strong>
                                                    </span> : <span
                                                        style={{

                                                            display: "inline-block",
                                                            width: "80%",
                                                            textAlign: "center",
                                                            backgroundColor:
                                                                row.ticket_status === "hold"
                                                                    ? "#D5D528" : row.ticket_status === "closed" ? "#D5D528" : row.ticket_status === "open" ? "#D59428" : "#D5D528",
                                                            color: "#393C46",
                                                            borderRadius: "5px",
                                                            padding: "2px 4px",
                                                        }}
                                                    >
                                                        <strong>{row.ticket_status.charAt(0).toUpperCase() + row.ticket_status.slice(1).toLowerCase()}</strong>
                                                    </span>)
                                            }
                                        </td>
                                        <td>
                                            <div>
                                                <strong>{row.project_building ? row.project_building.owner_name : 'N/A'}</strong>
                                                <br />
                                                <span>{row.project_building ? row.project_building.owner_email : 'N/A'}</span>
                                            </div>
                                        </td>

                                        {this.props.redux.globalVar.userTypeStyle !== '2' && (
                                            <td >
                                                <div>
                                                    {row.assign_to ? row.assign_to : 'N/A'}
                                                </div>
                                            </td>
                                        )}
                                        {this.props.redux.globalVar.userTypeStyle === '3' && (
                                            <td >
                                                <div>
                                                    {row.si_email ? row.si_email : 'N/A'}
                                                </div>
                                            </td>
                                        )}
                                        {this.props.redux.globalVar.userTypeStyle === '3' && (
                                            <td >
                                                <div>
                                                    {row.assign_to_distributor ? 'Y' : 'N'}
                                                </div>
                                            </td>
                                        )}
                                        <td>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 384 512"
                                                style={{
                                                    color: "#BAC6CE",
                                                    marginRight: "5px",
                                                    width: "12px",
                                                    height: "12px",
                                                }}
                                                fill="#BAC6CE"
                                            >
                                                <path d="M172.3 501.7C13.9 301.4 0 291.1 0 192 0 86 86 0 192 0s192 86 192 192c0 99.1-13.9 109.4-172.3 309.7-9.6 12.2-29.8 12.2-39.4 0zM192 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z" />
                                            </svg>
                                            {row.project_building ? row.project_building.address : 'N/A'}
                                        </td>
                                        <td> {row.subscription_data === null ? 'N' : row.subscription_data.status.charAt(0).toUpperCase() + row.subscription_data.status.slice(1).toLowerCase()}

                                        </td>
                                        <td>{row.remote_access ? "Y" : "N"}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <Link
                                                to={
                                                    (this.props.redux.globalVar.userTypeStyle === "3" ||
                                                        (this.props.redux.globalVar.userTypeStyle === "4" &&
                                                            this.state.checkuserApidata.source === 'Distributor'))
                                                        ? `/support2/${row.ticket_id}`
                                                        : `/support/${row.ticket_id}`
                                                }

                                            >
                                                <img src={View} alt="View Icon" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* Project manager Form start */}
                    {this.state.showmodels ?
                        <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                            <div className="selfmodal-dialog"
                                style={{
                                    width: this.props.windowWidth > 760 ? "50%" : "60%",

                                }}
                            >
                                <div className="selfmodal-content" style={{ marginTop: "100px" }}>
                                    <div className="modal-header" >
                                        <button type="submit" className="close" data-dismiss="modal"
                                            onClick={this.onclosemodel.bind(this)}
                                        >&times;</button>
                                        <h3 className="modal-title">Assign Ticket </h3>
                                        <h6>Select a User to assign the ticket to</h6>
                                    </div>
                                    <div className="modal-body"  >
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell sx={{ color: '#fff', fontSize: '11px' }}><strong>User Name</strong></TableCell>
                                                        <TableCell sx={{ color: '#fff', fontSize: '11px' }}><strong>Email</strong></TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.assignableUsers.map((user) => (
                                                        <TableRow key={user.id}>

                                                            <TableCell sx={{ fontSize: '11px' }}>{user.name}</TableCell>
                                                            <TableCell sx={{ fontSize: '11px' }}>{user.user_email}</TableCell>
                                                            <TableCell>
                                                                <Radio
                                                                    checked={this.state.selectedUserId === user.id}
                                                                    onChange={() => this.setState({ selectedUserId: user.id })}
                                                                    value={user.id}
                                                                    name="assign-user"
                                                                    sx={{
                                                                        color: '#f18c18',
                                                                        '&.Mui-checked': {
                                                                            color: '#f18c18',
                                                                        },
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                    </div>
                                    <br />
                                    <div className="modal-footer">
                                        <React.Fragment>
                                            <button type="button"
                                                onClick={this.onclosemodel.bind(this)}
                                                className="btn allbtn" data-dismiss="modal">
                                                Cancel
                                            </button>
                                            <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null}
                                                onClick={() => this.handleAssignTicket()}
                                                className="btn btn-primary allbtn" data-dismiss="modal">
                                                Assign
                                            </button>
                                        </React.Fragment>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}

                    {/* Project manager Form End */}
                    {/* Pagination */}
                    {/* Pagination Buttons */}
                    <div style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",

                    }}>
                        <button
                            onClick={this.handlePrevious}
                            disabled={!previous}
                            style={{
                                margin: "0 5px",
                                padding: "5px 10px",
                                backgroundColor: previous ? "#2980B9" : "#ECF0F1",
                                color: previous ? "#fff" : "#000",
                                border: "none",
                                borderRadius: "4px",
                                cursor: previous ? "pointer" : "not-allowed",
                            }}
                        >
                            Previous
                        </button>
                        <button
                            onClick={this.handleNext}
                            disabled={!next}
                            style={{
                                margin: "0 5px",
                                padding: "5px 10px",
                                backgroundColor: next ? "#2980B9" : "#ECF0F1",
                                color: next ? "#fff" : "#000",
                                border: "none",
                                borderRadius: "4px",
                                cursor: next ? "pointer" : "not-allowed",
                            }}
                        >
                            Next
                        </button>
                    </div>
                </span>

            </div>
        );
    }
}

const CustomLabel = ({ viewBox, labelText, value }) => {
    const { cx, cy } = viewBox;
    return (
        <g>
            <text
                x={cx}
                y={cy}
                fill="#393C46"
                className="recharts-text recharts-label"
                textAnchor="middle"
                dominantBaseline="central"
                alignmentBaseline="middle"
                fontSize="15"
            >
                {labelText}
            </text>
            <text
                x={cx}
                y={cy + 20}
                className="recharts-text recharts-label"
                textAnchor="middle"
                dominantBaseline="central"
                alignmentBaseline="middle"
                fill="#393C46"
                fontSize="26"
                fontWeight="600"
            >
                {value}
            </text>
        </g>
    );
};

const mapStateToProps = state => {
    return {
        redux: state,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        userNameStyleActivate: (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data: data }),
        reuserNameStyleActivate: (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data: data }),
        userTypeStyleActivate: (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Support); 